<template>
  <div class="user_info_form">
    <h4>계좌정보</h4>
    <p v-if="description" class="description">{{ description }}</p>
    <dl class="bankname">
      <dt>은행선택</dt>
      <dd class="form">
        <custom-selectbox
          @custom-select="updateBankName"
          :value="bankSelect"
          :items="bankNameList"
          firstItem="은행 선택"
        />
      </dd>
    </dl>
    <dl class="accountno">
      <dt>계좌번호</dt>
      <dd class="form">
        <v-input-number
          v-model="request.accountNo"
          @custom-input="updateAccountNo"
          @custom-enter="handleClick"
          placeholder="- 없이 계좌번호만 입력"
        />
        <v-button class="btn03" @handleClick="handleClick" :disabled="isState" text="인증" />
      </dd>
    </dl>
    <dl>
      <dt>계좌주</dt>
      <dd class="account_owner_name">{{ this.accountOwnerName }}</dd>
      <dd class="msg msg_business" :class="msgClass">
        <v-icon clsName="icon_check" />
        <v-icon clsName="icon_error" />
        {{ errorMsg }}
      </dd>
    </dl>
    <div v-if="isButton" class="bt">
      <v-button @handleClick="cancelClick" class="btn12 btn_cancel" text="수정취소" />
      <v-button @handleClick="submitClick" :disabled="!isState" class="btn11 btn_complete" text="수정완료" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VInputNumber from '@/components/atoms/VInputNumber';
import CustomSelectbox from '@/components/atoms/CustomSelectbox';
import VButton from '@/components/atoms/VButton';
import VIcon from '@/components/atoms/VIcon';
import eventBus from '@/utils/eventBus';
import mixin from '@/utils/mixin';
import _ from 'lodash';

export default {
  mixins: [mixin],
  components: {
    VInputNumber,
    CustomSelectbox,
    VButton,
    VIcon,
  },
  props: {
    description: {
      type: String,
      default: '',
    },
    isButton: {
      type: Boolean,
      default: false,
    },
    businessType: {
      type: Number,
      default: 0,
    },
    businessLicenseNumber: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      errorMsg: '',
      errorCode: '',
      msgClass: '',
      prevAccount: '',
      bankSelect: -1,
      bankName: '',
      request: {},
      isState: false,
      accountOwnerName: '',
    };
  },
  computed: {
    ...mapGetters('exchange', ['bankNameList', 'bankList']),
    ...mapGetters('userInfo', ['userInfo']),
    businessInfo() {
      return this.businessLicenseNumber || this.userInfo.businessLicenseNumber;
    },
    requestCheck() {
      if (this.businessType == 1) {
        return {
          businessType: this.businessType,
        };
      } else {
        return {
          businessLicenseNumber: this.removeComma(this.businessInfo),
          businessType: this.businessType,
        };
      }
    },
  },
  methods: {
    ...mapActions('exchange', ['getBankList']),
    ...mapActions('userInfo', ['updateUserInfo', 'checkBankAccount', 'setModifyAccount']),
    updateAccount() {
      this.$emit('update', {
        request: this.isState ? this.request : '{}',
        isState: this.isState,
        accountOwnerName: this.accountOwnerName,
      });
    },
    updateBankName(val) {
      this.bankSelect = val;
      this.request.bankCode = this.bankList[val].bankCode;
      this.checkAccount();
    },
    updateAccountNo(val) {
      this.accountNo = val;
      this.checkAccount();
    },
    checkAccount() {
      if (
        this.prevAccount != '' &&
        this.prevAccount != this.request.bankCode + this.request.accountNo + this.businessLicenseNumber
      ) {
        this.msgClass = 'red';
        this.errorMsg = '정보가 변경 되어 다시 인증하셔야 합니다.';
        this.isState = false;
        this.accountOwnerName = '';
        this.updateAccount();
      }
    },
    async handleClick() {
      if (this.bankSelect === -1) {
        this.msgClass = 'red';
        this.errorMsg = '은행을 선택하세요.';
        return;
      }
      if (!this.request.accountNo) {
        this.msgClass = 'red';
        this.errorMsg = '계좌번호를 입력하세요.';
        return;
      }
      if (this.businessType != 1 && this.businessInfo == '') {
        this.msgClass = 'red';
        this.errorMsg = '사업자등록번호를 먼저 입력하세요.';
        return;
      }

      const apiReturn = await this.checkBankAccount({
        ...this.request,
        ...this.requestCheck,
      });
      if (apiReturn.code === 0) {
        this.isState = true;
        this.accountOwnerName = apiReturn.data.accountOwnerName;
        this.updateAccount();
      }
      this.errorCode = apiReturn.code;
      if (apiReturn.code > 0) {
        this.msgClass = 'red';
        this.errorMsg = '본인 계좌 번호만 입력 가능합니다.';
      } else if (apiReturn.code === 0) {
        this.msgClass = 'blue';
        this.errorMsg = '본인 계좌 번호로 확인되었습니다.';
        this.prevAccount = this.request.bankCode + this.request.accountNo + this.businessLicenseNumber;
      }
    },
    businessInfoUpdate() {
      this.$nextTick(() => {
        this.checkAccount();
      });
    },
    cancelClick() {
      this.$emit('cancel-click');
    },
    async submitClick() {
      const apiReturn = await this.setModifyAccount({ ...this.request, businessType: this.userInfo.businessType });
      if (apiReturn.code === 0) {
        this.bankName = _.find(this.bankList, { bankCode: apiReturn.data.bankCode }).bankName;
        this.updateUserInfo({
          bankName: this.bankName,
          accountNo: apiReturn.data.accountNo,
        });
        this.$emit('cancel-click');
      }
    },
  },
  mounted() {
    eventBus.$on('businessInfoUpdate', this.businessInfoUpdate);
  },
  beforeDestroy() {
    eventBus.$off('businessInfoUpdate', this.businessInfoUpdate);
  },
  async created() {
    await this.getBankList();
  },
};
</script>
<style lang="scss" scoped>
.user_info_form {
  dl {
    margin-bottom: 15px;
  }
}
</style>
